import { render, staticRenderFns } from "./DoctorRegister.vue?vue&type=template&id=9f5e0642&"
import script from "./DoctorRegister.vue?vue&type=script&lang=js&"
export * from "./DoctorRegister.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegister.vue?vue&type=style&index=0&id=9f5e0642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports